import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { EditStudentForm } from '@/features/student'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/users/students/update/$studentId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { t } = useTranslation()
  const { studentId } = Route.useParams()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Редактирование ученика')}>
      <EditStudentForm onClose={close} studentId={studentId} />
    </Offcanvas>
  )
}
